module.exports = __webpack_public_path__ + "static/media/pool.9cec2c19.svg";